import type { QuestionModule } from "../contracts";
import { rowSpecifyFields } from "../specify/rowFields";
import {
  gridRatingCore,
  type GridRatingDefinition,
  type GridRatingDraft,
  type GridRatingEvent,
  type GridRatingRaw,
  type GridRatingResponse,
} from "./core";
import {
  GridRatingButtonsView,
  GridRatingSliderView,
  GridRatingStarsView,
} from "./views";

export const gridRatingModule: QuestionModule<
  GridRatingRaw,
  GridRatingDefinition,
  GridRatingDraft,
  GridRatingEvent,
  GridRatingResponse
> = {
  type: "grid_rating",
  galleryFeatures: [
    "visual-groups",
    "row-custom-text",
    "baseline",
    "rows",
    "labels",
    "images",
    "row-images",
    "restored",
    "dont-know",
    "unanswered",
    "non-one-based",
  ],
  core: gridRatingCore,
  prompt: (definition) => ({
    content: definition.prompt,
    image: definition.image,
    altText: definition.altText,
    error: definition.error,
  }),
  views: {
    buttons: {
      id: "buttons",
      label: "Buttons",
      component: GridRatingButtonsView,
      space: "expanded",
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action"],
    },
    slider: {
      id: "slider",
      label: "Slider",
      component: GridRatingSliderView,
      space: "expanded",
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action"],
    },
    star: {
      id: "star",
      label: "Stars",
      component: GridRatingStarsView,
      space: "expanded",
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action"],
    },
  },
  defaultDisplay: { view: "slider" },
  resolveDisplay: (raw) => ({
    view: raw.style === "button" ? "buttons" : raw.style,
  }),
  controls: (definition, draft, _display, copy) => ({
    specify: [
      ...rowSpecifyFields(
        definition.rows,
        draft.specifiedRows ?? {},
        (rowId, value): GridRatingEvent => ({
          type: "set-row-label",
          rowId,
          value,
        }),
      ),
    ],
    primaryAction: {
      purpose: "submit",
      label: copy.actions.send,
      action: { type: "submit" },
    },
  }),
};
